import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TiimeOptionModule, TiimeFormModule, TiimeInputContainerModule, TiimeSelectModule } from 'tiime-material';

import { SelectBase } from '@bases/selector/select.base';
import { CodeAndLabel } from '@models/code-and-label';
import { ListErrorComponent } from '@shared-components/list-error/list-error.component';
import { FormFocusObserveDirective } from '@shared-directives/form-focus-observe/form-focus-observe.directive';

@Component({
  selector: 'app-code-and-label-select',
  standalone: true,
  imports: [
    TiimeOptionModule,
    TiimeFormModule,
    TiimeInputContainerModule,
    TiimeSelectModule,
    FormFocusObserveDirective,
    ReactiveFormsModule,
    ListErrorComponent
  ],
  templateUrl: './code-and-label-select.component.html',
  styleUrls: ['./code-and-label-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CodeAndLabelSelectComponent<T extends string = string> extends SelectBase<CodeAndLabel<T>> {
  @Input({ required: true }) options: CodeAndLabel<T>[];
  @Input({ required: true }) label: string;
  @Input() contentId: string;
}
